export const useT = (key, payload, options) => useNuxtApp().$i18n.t(key, payload, options);
export const useD = (key, payload) => useNuxtApp().$i18n.d(key, payload); // DateTime localization
export const useN = (key, payload) => useNuxtApp().$i18n.n(key, payload); // Number localization
